import { Navigate, useParams } from 'react-router-dom';

import Project from '../components/Selection/Projects/Project';
import TopicsList from '../components/Selection/Theme';
import Topics from '../components/Selection/Theme/Topics';
import ScoreStageList from '../components/Selection/ScoreStages';
import PersonManagement from '../components/Selection/ScoreStages/PersonManagement';
import ScoreStageTopicList from '../components/Selection/ScoreStages/Topics';
import ScoringSettings from '../components/Selection/ScoreStages/ScoringSettings';
import Assing from '../components/Selection/ScoreStages/Assign';
import ResetAssing from '../components/Selection/ScoreStages/ResetAssign';
import Cases from '../components/Selection/ScoreStages/Cases';
import Case from '../components/Selection/ScoreStages/Case';
import List from '../components/Selection/ScoreStages/List';
import VoteTopics from '../components/Selection/Vote/Topics';
import Settings from '../components/Selection/Vote/Settings';
import PrivilegedUsers from '../components/Selection/Vote/PrivilegedUsers';
import VoteCases from '../components/Selection/Vote/Cases';
import LabourExpenses from '../components/Selection/LabourExpenses';

import { SELECTION_WORKSPACE_ROUTE_BASE } from '../layouts/selectionWorkspaceConfig';
import { workspaceSelectionDeclarationsPath } from '../layouts/selectionWorkspacePaths';

function SelectionWorkspaceIndexRoute() {
    const { pid } = useParams();
    if (pid === 'new') return <Project />;
    return <Navigate to={workspaceSelectionDeclarationsPath(pid)} replace />;
}

function SelectionWorkspaceUnknownRedirect() {
    const { pid } = useParams();
    return <Navigate to={`${SELECTION_WORKSPACE_ROUTE_BASE}/${pid}`} replace />;
}

const selectionWorkspaceLayoutRoutes = [
    { index: true, element: <SelectionWorkspaceIndexRoute /> },
    { path: 'info', element: <Project /> },
    { path: 'declarations', element: <TopicsList /> },
    { path: 'declarations/add', element: <Topics /> },
    { path: 'declarations/:id', element: <Topics /> },
    { path: 'vote', element: <VoteTopics /> },
    { path: 'vote/topics/:tid/settings', element: <Settings /> },
    { path: 'vote/topics/:tid/privileged-users', element: <PrivilegedUsers /> },
    { path: 'vote/topics/:tid/cases', element: <VoteCases /> },
    { path: 'labour-expenses', element: <LabourExpenses /> },
    { path: 'reviews', element: <ScoreStageList /> },
    { path: 'reviews/:id/personnel-management', element: <PersonManagement /> },
    { path: 'reviews/:id/topics', element: <ScoreStageTopicList /> },
    { path: 'reviews/:id/scoring-settings/:tid', element: <ScoringSettings /> },
    { path: 'reviews/:id/assign', element: <Assing /> },
    { path: 'reviews/:id/reset-assign', element: <ResetAssing /> },
    { path: 'reviews/:sid/topics/:tid/cases', element: <Cases /> },
    { path: 'reviews/:sid/topics/:tid/cases/:id', element: <Case /> },
    { path: 'reviews/:sid/topics/:tid/cases/list', element: <List /> },
    { path: '*', element: <SelectionWorkspaceUnknownRedirect /> },
];

export default selectionWorkspaceLayoutRoutes;
